import React, {Component} from 'react';
import graphql from '../../../helpers/graphql.js';
import CompetitionForm from '../../../components/CompetitionForm';

class Competition extends Component {
  constructor (props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.returnToStart = this.returnToStart.bind(this);
    this.state = {
      success: false
    };
  }

  returnToStart () {
    this.setState({success: false});
  }

  handleSubmit (fields) {
    graphql.sendContactMessage(fields).then(response => {
      if (response.contactFormMutation.success) {
        this.setState({success: true});
      }
    });
  }

  render () {
    let pageContent = <CompetitionForm onSubmitClick={this.handleSubmit} />;
    if (this.state.success) {
      pageContent = <div style={{textAlign: 'center', marginTop: 250, marginBottom: 200}}>
        <h1>
          Thank you, you're competition entry has been received.
        </h1>
        <div style={{paddingTop: 20}}>
          <button onClick={this.returnToStart} className='button button--shadow button--l'>Return to competition entry form</button>
        </div>
      </div>;
    }
    return (
      <main className='main'>
        {pageContent}
      </main>
    );
  }
}

export default Competition;



// WEBPACK FOOTER //
// ./src/views/Main/Competition/index.js